import { Box, Button, Modal, TextField } from '@mui/material';
import React from 'react';

function Blogmodel(props) {
  const { open, handleChange, fielderror, handleClick, handleClose } = props;

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 4,
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField type="title" name="title" onChange={handleChange} label="title" />
            <div style={{ color: 'red' }}>{fielderror.title}</div>
            <TextField style={{ marginTop: '10px' }} type="url" name="url" onChange={handleChange} label="url" />
            <div style={{ color: 'red' }}>{fielderror.url}</div>

            <Button style={{ marginTop: '10px' }} variant="contained" color="primary" onClick={handleClick}>
              Submit
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default Blogmodel;
